export { default as AuthRoute } from "./AuthRoute";
export { default as AnimRoute } from "./AnimRoute";
export { default as AdminRoute } from "./AdminRoute";



// WEBPACK FOOTER //
// ./src/components/routes/index.js